import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-compass-3-fill text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl text-foreground-950">九色导航</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/articles"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/article')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-200'
              }`}
            >
              文章
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer text-foreground-700 hover:bg-background-200"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-in slide-in-from-top-2 duration-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 whitespace-nowrap cursor-pointer">首页</Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/articles" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 whitespace-nowrap cursor-pointer">文章</Link>
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 whitespace-nowrap cursor-pointer">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}